jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/accordion.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/owl.js');
});


// Background Color
const banner = document.querySelector('.banner');

const sectionColor = function(color, EL) {

  if(color.classList.contains('background-light-teal')) {
    EL.classList.add('background-light-teal');

  } else if(color.classList.contains('background-main')) {
    if(color.classList.contains('section-curve')) {
      EL.classList.add('background-green');

    } else {
      EL.classList.add('background-main');
    }

  } else if(color.classList.contains('background-green')) {
    EL.classList.add('background-green');

  } else if(color.classList.contains('background-white')) {
    EL.classList.add('background-white');
  }

}

if(banner) {
  sectionColor(banner.nextSibling, banner);
};


// Section Padding
const instagram = document.querySelector('#sb_instagram');
const mainLastChild = document.querySelector('main').lastElementChild;

const sectionPaddingBottom = function(EL) {
  EL.style.paddingBottom = '14rem';
};

if(instagram) {
  sectionPaddingBottom(mainLastChild);
};